import { API, get, Filter, post, put, remove } from "api";
import { OK } from "http-status-codes";

export interface Creatives {
    width: number;
    height: number;
    target: string;
}

export interface CreativeMapping {
    filters: Filter[];
    creatives: Creatives[];
}

export interface CreativeMappings extends CreativeMapping {
    id: number;
}

export const getCreativeMappings = async (headers: HeadersInit): Promise<CreativeMappings[]> => {
    const { parsedBody } = await get<{ mappings: CreativeMappings[] }>(`${API.baseApiUrl}/creative-mappings`, {
        headers,
    });

    return parsedBody?.mappings || [];
};

export const createCreativeMapping = async (
    { filters, creatives }: CreativeMapping,
    headers: HeadersInit
): Promise<number> => {
    await post(
        `${API.baseApiUrl}/creative-mappings`,
        {
            creatives,
            // TODO: backend needs to adjust this naming
            filter: filters,
        },
        {
            headers: {
                ...headers,
                "Content-Type": "application/json",
            },
        }
    );

    return OK;
};

export const updateCreativeMapping = async (
    { id, filters, creatives }: CreativeMapping & { id?: number },
    headers: HeadersInit
): Promise<number> => {
    await put(
        `${API.baseApiUrl}/creative-mappings/${id}`,
        {
            creatives,
            // TODO: backend needs to adjust this naming
            filter: filters,
        },
        {
            headers: {
                ...headers,
                "Content-Type": "application/json",
            },
        }
    );

    return OK;
};

/**
 * Delete mapping
 * @param id Mapping id
 * @param headers
 */
export const deleteCreativeMapping = async (id: number, headers: HeadersInit): Promise<number> => {
    await remove(`${API.baseApiUrl}/creative-mappings/${id}`, {
        headers,
    });

    return OK;
};
